import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Cell } from '../components';
export function renderDndColumns(columns, cellProps) {
    return columns.map(({ component: Component, name, contentType, title }) => (_createElement(Cell, { ...(contentType ? { contentType } : { title: title ?? name }), key: name }, Component && _jsx(Component, { column: { name, contentType, title }, ...cellProps }))));
}
